// 顧客宛文書編集

// エラーメッセージの初期値
export const init_error_message = {
  title: '',
  comment: '',
  file: '',
  target_customer: '',
  start_date: '',
  end_date: '',
  authorizer_id: '',
};

// 登録ボタンを非表示にするステータス
export const register_button_hidden_status = [ 4 ];

// 対象顧客選択ダイアログの検索結果の1ページの最大表示件数
export const customer_select_max_line = 100;

// 画面遷移先の画面ID
export const KWANKGM10100 = 'KWANKGM10100'; // 顧客宛文書編集（確認）
export const KWANKGM10110_Complete = 'KWANKGM10110_Complete'; // 顧客宛文書編集（完了）-編集完了
export const KWANKGM10110_Delete = 'KWANKGM10110_Delete'; // 顧客宛文書編集（完了）-削除完了
export const ValidDelete = 'ValidDelete'; // 削除確認に画面IDはないので固有名をつける
